import { IsNotEmpty, IsNumber, IsString, Min } from 'class-validator';
import { first } from 'lodash';

import createDocumentResource from 'src/actions/shared/createDocumentResource';
import RoutingGroup from 'src/models/RoutingGroup/RoutingGroup';
import { EndpointTypes } from 'src/models/Channels/endpointType';
import { STATUS_UNSTARTED } from 'src/presentation/hooks/useResource';

export class ChannelsConfig {
  @IsString()
  @IsNotEmpty({ message: 'Default inbox must not be empty' })
  defaultInbox: string;

  @IsNumber()
  @Min(0, { message: 'Default SLA seconds must be greater than or equal to 0' })
  defaultSLASeconds: number;
}

const channelsConfigurationResource = createDocumentResource<ChannelsConfig>({
  name: 'channelsConfiguration',
  endpoint: 'v1/orgs/:orgId/configuration/channels',
  type: ChannelsConfig,
});

export const getDefaultChannelConfiguration =
  (endpointType: EndpointTypes | string) =>
  async (dispatch, getState, { gateways }): Promise<[string | undefined, number | undefined] | undefined> => {
    const { values: routingGroupsStored, loadingState: routingGroupsLoadingState } = getState().routingGroups;
    const { value: channelsConfigurationsStored, loadingState } = getState().channelsConfiguration;

    const channelsConfigurations =
      loadingState === STATUS_UNSTARTED ? await gateways.channelsConfiguration.fetch({}) : channelsConfigurationsStored;

    if (channelsConfigurations[endpointType]?.defaultInbox) {
      return [
        channelsConfigurations[endpointType]?.defaultInbox,
        channelsConfigurations[endpointType]?.defaultSLASeconds,
      ];
    }

    const routingGroups: RoutingGroup[] =
      routingGroupsLoadingState === STATUS_UNSTARTED ? await gateways.routingGroups.requestAll() : routingGroupsStored;

    return [first(routingGroups)?.id, undefined];
  };

export default channelsConfigurationResource;
